import { render, staticRenderFns } from "./NoticeEdit.vue?vue&type=template&id=04734d2f&scoped=true&"
import script from "./NoticeEdit.vue?vue&type=script&lang=js&"
export * from "./NoticeEdit.vue?vue&type=script&lang=js&"
import style0 from "./NoticeEdit.vue?vue&type=style&index=0&id=04734d2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04734d2f",
  null
  
)

export default component.exports